import React, { useState, useEffect } from "react";
import LandingPage from "./LandingPage";
import WhiteLabelPage from "./WhiteLabelPage";
import BusinessCheckPage from "./BusinessCheckPage";
import LegalPage from "./LegalPage";

// >>> HIER die Domain deiner Software eintragen (bzw. via REACT_APP_APP_URL) <<<
const APP_URL = process.env.REACT_APP_APP_URL || "https://app.business-studio-suite.com";

// Diese App.js ersetzt die bisherige aus dem ersten ZIP.
// Sie schaltet ohne react-router zwischen den Seiten um.
// Sprache bestimmen: gespeicherte Wahl > Browsersprache > Deutsch.
const detectInitialLang = () => {
  if (typeof window === "undefined") return "de";
  const saved = localStorage.getItem("ss_lang");
  if (saved === "de" || saved === "en") return saved;
  return "de";
};

export default function App() {
  const [page, setPage] = useState("landing"); // "landing" | "whitelabel" | "businesscheck" | "impressum" | "agb" | "datenschutz"
  const [lang, setLangState] = useState(detectInitialLang); // "de" | "en" – Landing Page & White-Label-Seite sind zweisprachig (Rechtstexte nur DE)
  const setLang = (l) => { setLangState(l); try { localStorage.setItem("ss_lang", l); } catch (e) {} };

  // <html lang="..."> an die gewählte Sprache anpassen (SEO / Barrierefreiheit).
  useEffect(() => { if (typeof document !== "undefined") document.documentElement.lang = lang; }, [lang]);

  const goToApp = () => { window.location.href = APP_URL; };
  const show = (p) => { setPage(p); window.scrollTo({ top: 0 }); };
  const back = () => show("landing");

  if (page === "whitelabel") {
    return <WhiteLabelPage onLogin={goToApp} onBack={back} isLoggedIn={false} lang={lang} />;
  }
  if (page === "businesscheck") {
    return <BusinessCheckPage onBack={back} onWhiteLabel={() => show("whitelabel")} lang={lang} />;
  }
  if (page === "impressum" || page === "agb" || page === "datenschutz") {
    return <LegalPage docKey={page} onBack={back} />;
  }
  return (
    <LandingPage
      onDemo={goToApp}
      onLogin={goToApp}
      onWhiteLabel={() => show("whitelabel")}
      onBusinessCheck={() => show("businesscheck")}
      onImpressum={() => show("impressum")}
      onDatenschutz={() => show("datenschutz")}
      onAgb={() => show("agb")}
      demoLoading={false}
      isLoggedIn={false}
      lang={lang}
      setLang={setLang}
    />
  );
}
